<template>
  <b-modal id="add-owner-modal">
    <template v-slot:modal-header="">
      <h5>إضافة مالك</h5>
    </template>

    <template v-slot:default="">
      <div class="form-group text-right">
        <label class="small">اسم المالك:</label>
        <input
          class="form-control"
          placeholder="اسم المالك"
          :value="ownersSearchTerm"
          @keyup="ownersSetSearchTerm($event.target.value)"
        />
      </div>

      <div v-if="ownersSearchTerm && ownersFilter.length > 0" class="form-group">
        <div class="clients-list">
          <div v-for="(owner, i) in ownersFilter" :key="i" class="list-row" @click="addOwnerTap(owner)">
            {{ owner.name }}
          </div>
        </div>
      </div>
    </template>

    <template v-slot:modal-footer="">
      <button type="submit" class="btn btn-primary" @click="submit">حفظ</button>
      <a
        href="#"
        class="text-muted"
        @click="$bvModal.hide('add-owner-modal')"
        >إغلاق</a
      >
    </template>
  </b-modal>
</template>

<script>
import OwnersMixin from '@/mixins/owners'
import PropertiesMixin from '@/mixins/properties'

export default {
    mixins: [OwnersMixin, PropertiesMixin],

  data() {
    return {
      selectedAgent: {
        name: "dfsfd",
        email: "adjfsd@dsf.com",
        mobile: "21121212",
        workAddress: "sdfsdfsdf",
        idNumber: "121212",
        idCardImage: "http://via.placeholder.com/100",
      },
    };
  },

  methods: {
    submit() {},

    updateImage(e) {
      this.$refs.idCardPreview.src = URL.createObjectURL(e.target.files[0]);
    },

    addOwnerTap (owner) {
        this.selectOwner(owner)
        this.addOwner().then((res) => {
            // this.showSwal(res)
            if (res.success) {
                this.$bvModal.hide('add-owner-modal')
            }
        })
    }
  },
};
</script>